$(document).ready(function() {
  var elem = document.querySelector("#terrazasListadoVue");
  if (elem == null) {
    return;
  }

  var vueAppTerrazas;

  window.callbackFiltros = (form) => {
    console.log("111")
    vueAppTerrazas.filtrarForm(form);
  }

  vueAppTerrazas = new Vue({
    el: elem,
    data: {
      loader: false,
      filtros: {page: 1, last_page: 1, fecha: null, lugar: null,
        tipo_evento_id: null, ordenar: null,},
      terrazas: []
    },
    computed: {
      urlParams(){
        let params = Object.assign({}, this.filtros)
        params = Object.fromEntries(Object.entries(params).filter(([_, v]) => (v != null && v != 'null')));
        delete params.page
        return new URLSearchParams(params).toString()
      }
    },
    mounted() {
      try{
        if(window.location.search.length > 0){
          const searchParams = new URLSearchParams(window.location.search);
          const decodedParams = Array
            .from(searchParams.keys())
            .reduce((acc, key) => ({ ...acc, [key]: searchParams.get(key) }), {});
          this.filtros = {...this.filtros,...decodedParams}
        }
      }
      catch (error){
        ReportErrorLog(error)
        console.error(error)
      }
      this.getTerrazas()
    },
    methods: {
      getTerrazaUrl(terraza){

        let params = new URLSearchParams();
        if(this.filtros.fecha != null){
          params.set('fecha', this.filtros.fecha)
        }

        if(this.filtros.tipo_evento_id != null){
          params.set('tipo_evento_id', this.filtros.tipo_evento_id)
        }

        return '/terraza/' + terraza.slug + '_' + terraza.id + "?" + params.toString()
      },
      setOrden(orden){
        this.filtros.ordenar = orden;
        this.getTerrazas(1);
      },
      nextPagina(){
        if(this.filtros.page < this.filtros.last_page){
          this.filtros.page += 1
          this.getTerrazas()
        }
      },
      getTerrazas(pagina = null){
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.misTerrazasPagina = pagina

        }
        this.loader = true
        axios
          .get('/terrazas-json', {
            params: this.filtros,
          })
          .then((response) => {
            vueAppTerrazas.loader = false
            if (response.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            let terrazasListado = response.data.terrazas.data
            for(let index in terrazasListado){
              terrazasListado[index].amenidades_cortas
                = terrazasListado[index].amenidades_cortas.slice(0, 3)
            }

            if(response.data.terrazas.current_page == 1){
              vueAppTerrazas.terrazas = []
            }

            vueAppTerrazas.terrazas = [...vueAppTerrazas.terrazas,...terrazasListado]

            vueAppTerrazas.filtros.total = response.data.terrazas.total;
            vueAppTerrazas.filtros.last_page = response.data.terrazas.last_page;
            vueAppTerrazas.filtros.per_page = response.data.terrazas.per_page;
            vueAppTerrazas.filtros.from = response.data.terrazas.from;
            vueAppTerrazas.filtros.to = response.data.terrazas.to;
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueAppTerrazas.loader = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      },

      filtrarForm(form){
        let formData = new FormData(form)
        var object = {};
        formData.forEach(function(value, key){
          if(key.indexOf("[") > -1){
            let keyExtra = key.replace("[]", "");
            if(object[keyExtra] == null){
              object[keyExtra] = [];
            }
            object[keyExtra].push(value);
          }
          else{
            if(value.length > 0){
              object[key] = value;
            }
          }
        });

        this.filtros = {...this.filtros,...object}
        this.getTerrazas(1)
      }
    }
  });

});
